import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useAccessControl = (userId: string, isOpen: boolean) => {
  const [selectedFeatures, setSelectedFeatures] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isOpen && userId) {
      loadUserFeatures();
    }
  }, [isOpen, userId]);

  const loadUserFeatures = async () => {
    try {
      const { data, error } = await supabase
        .from('owner_users')
        .select('hidden_features')
        .eq('user_id', userId)
        .single();

      if (error) throw error;
      
      // Ensure we're setting an array of strings
      const features = Array.isArray(data?.hidden_features) 
        ? data.hidden_features.map(feature => String(feature))
        : [];
      
      setSelectedFeatures(features);
    } catch (error) {
      console.error('Error loading user features:', error);
      toast.error("Erreur lors du chargement des accès");
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const { error } = await supabase
        .from('owner_users')
        .update({ hidden_features: selectedFeatures })
        .eq('user_id', userId);

      if (error) throw error;
      toast.success("Accès mis à jour avec succès");
      return true;
    } catch (error) {
      console.error('Error updating user features:', error);
      toast.error("Erreur lors de la mise à jour des accès");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    selectedFeatures,
    setSelectedFeatures,
    isLoading,
    handleSubmit,
  };
};